interface PayloadRecord {
	tags: string[];
	el: HTMLElement;
}

class Payloads {
	payloadsData: PayloadRecord[] = [];

	DOM!: {
		typeSelect: HTMLSelectElement;
		droneSelect: HTMLSelectElement;
		compliance: HTMLSelectElement;
		payloads: NodeListOf<HTMLElement>;
	};

	constructor() {
		this.DOM = {
			typeSelect: document.querySelector('.js-payloadType') as HTMLSelectElement,
			droneSelect: document.querySelector('.js-droneType') as HTMLSelectElement,
			payloads: document.querySelectorAll('.js-payload'),
			compliance: document.querySelector('.js-compliance') as HTMLSelectElement,
		};
		this.setPayloadsData();
		this.events();
		this.handleQueryParams();
	}

	events() {
		this.DOM.typeSelect.addEventListener('change', this.onChange.bind(this));
		this.DOM.droneSelect.addEventListener('change', this.onChange.bind(this));
		this.DOM.compliance.addEventListener('change', this.onChange.bind(this));
	}

	handleQueryParams() {
		const urlParams = new URLSearchParams(window.location.search);
		const drone = urlParams.get('drone');
		const type = urlParams.get('type');
		const droneOptions = Array.from(this.DOM.droneSelect.options).map((el) => el.value);
		const typeOptions = Array.from(this.DOM.typeSelect.options).map((el) => el.value);
		if (drone && droneOptions.indexOf(drone) > -1) {
			this.DOM.droneSelect.value = drone;
			this.DOM.droneSelect.dispatchEvent(new Event('change', { bubbles: true }));
		}
		if (type && typeOptions.indexOf(type) > -1) {
			this.DOM.typeSelect.value = type;
			this.DOM.typeSelect.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}

	onChange() {
		const type = this.DOM.typeSelect.value;
		const drone = this.DOM.droneSelect.value;
		const compliance = this.DOM.compliance.value;

		for (let i = 0; i < this.payloadsData.length; i++) {
			if (
				(this.payloadsData[i].tags.indexOf(type) > -1 || type === '*') &&
				(this.payloadsData[i].tags.indexOf(drone) > -1 || drone === '*') &&
				(this.payloadsData[i].tags.indexOf(compliance) > -1 || compliance === '*')
			) {
				this.payloadsData[i].el.classList.add('js-active');
			} else {
				this.payloadsData[i].el.classList.remove('js-active');
			}
		}
	}

	setPayloadsData() {
		this.payloadsData = Array.from(this.DOM.payloads).map((el) => ({
			tags: (el.dataset.tags ?? '').split(','),
			el,
		}));
	}
}

const typeSelect = document.querySelector('.js-payloadType');
const droneSelect = document.querySelector('.js-droneType');
const compliance = document.querySelector('.js-compliance');

if (typeSelect && droneSelect && compliance) {
	new Payloads();
}
